import IAppStore from "app/IAppStore";
import ProducerNotificationPreferences from "features/settings/producers/ProducerNotificationPreferences";
import SetTraderContactDetails from "features/settings/traders/SetTraderContactDetails";
import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import NotificationSettings from "./NotificationSettings";

type NotificationModalProps = {
    onClose(): void;
};

const NotificationModal: React.FC<NotificationModalProps> = props => {
    const isCustomer = useSelector((m: IAppStore) => m.userState.isCustomer);

    if (!isCustomer) return <Modal show onHide={props.onClose} backdrop="static">
        <Modal.Header closeButton>
            <Modal.Title>Settings</Modal.Title>
        </Modal.Header>

        <Modal.Body>
            <SetTraderContactDetails />
            <NotificationSettings />
        </Modal.Body>

        <Modal.Footer>
            <Button variant="primary" onClick={props.onClose}>
                Close
            </Button>
        </Modal.Footer>
    </Modal>;

    return <ProducerNotificationPreferences
        producer={null}
        handleClose={props.onClose} />
}

export default NotificationModal;